export default __webpack_public_path__ + "3880bd2727cb60d8088cec94f1995778.svg";